<template>
    <div>
        <b-card no-body>
            <b-card-header>
                <h5>PARÂMETROS</h5>
            </b-card-header>
            <b-card-body>
                <app-tabela
                    :itens="parametros"
                    :campos="campos"
                    :itensPorPagina="itensPorPagina"
                    :bordered="false"
                    :small="false"
                >
                    <template slot="botoes">
                        <!-- <b-button-group class="float-right">
                            <b-button
                                variant="success"
                                @click="reiniciarJobs()"
                                v-if="mostrarBtnReiniciarJobs"
                                >Reiniciar Jobs</b-button
                            >
                        </b-button-group> -->
                    </template>
                    <!-- <template slot="cpfCnpj" slot-scope="data">
                        <span>{{ data.cpfCnpj | toCpfCnpj }}</span>
                    </template> -->
                    <template slot="acoes" slot-scope="data">
                        <!-- <span
                            class="text-primary"
                            v-if="$temAcessoView('ADMIN-JOBS-00')"
                        >
                            <i
                                class="fa fa-info-circle fa-lg icon-button"
                                title="Detalhar"
                                @click.stop="detalharJob(data.jobId)"
                            ></i>
                        </span> -->
                        <btn-atualizar
                            :parametro="data"
                            @atualizar-lista="obterParametros()"
                            v-if="$temAcessoView('ADMIN-PARAMETROS-01')"
                        ></btn-atualizar>
                    </template>
                </app-tabela>
            </b-card-body>
        </b-card>
        <!-- <router-view :job="job" v-if="job.jobId"></router-view> -->
    </div>
</template>

<script>
import ParametrosServicos from './ParametrosServicos'
import BtnAtualizar from './BtnAtualizar'

export default {
    components: {
        BtnAtualizar
    },

    data() {
        return {
            parametros: [],
            parametro: {},
            campos: [
                {
                    key: 'codParametro',
                    label: 'Parâmetro',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'descricao',
                    label: 'Descrição',
                    filterable: true
                },
                {
                    key: 'valor',
                    label: 'Valor',
                    filterable: true
                },
                {
                    key: 'detalhe',
                    label: 'Detalhe',
                    filterable: true
                },
                {
                    key: 'dataAtualizacao',
                    label: 'Atualizado em',
                    type: 'datetime'
                },
                {
                    key: 'acoes',
                    label: 'Ações'
                }
            ],
            itensPorPagina: 10
        }
    },

    methods: {
        obterParametros() {
            this.$store.dispatch('addRequest')
            ParametrosServicos.obterTodos().then(response => {
                if (response) {
                    if (response.success) {
                        this.parametros = response.data
                    } else {
                        this.$toast.error(
                            'Erro ao obter parâmetros',
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        }

        // detalharJob(jobId) {
        //     this.job = this.jobs.filter(p => {
        //         return p.jobId == jobId
        //     })[0]
        //     this.$router.push({
        //         name: 'Jobs_Detalhar',
        //         params: {
        //             jobId
        //         }
        //     })
        // },

        // reiniciarJobs() {
        //     this.$store.dispatch('addRequest')
        //     JobsServicos.reiniciarJobs().then(response => {
        //         if (response) {
        //             if (response.success) {
        //                 this.$toast.success(
        //                     'Jobs reiniciados com sucesso',
        //                     'OK',
        //                     this.$toastConfig.success
        //                 )
        //             } else {
        //                 this.$toast.error(
        //                     'Erro ao reiniciar jobs',
        //                     'ERROR',
        //                     this.$toastConfig.error
        //                 )
        //             }
        //         }
        //         this.$store.dispatch('removeRequest')
        //     })
        // }
    },

    created() {
        this.obterParametros()
    },

    computed: {
        // mostrarJobs() {
        //     return this.$route.name == 'Jobs'
        // },
        // mostrarBtnReiniciarJobs() {
        //     return this.$temAcessoView('ADMIN-JOBS-01')
        // }
    },

    watch: {}
}
</script>
